import { baseURL } from '../../../base-url.js'
import axios from 'axios'

export default {
  async loadEmployees({ commit }, salonId) {
    const token = localStorage.getItem('jwt')
    const response = await axios.get(baseURL + '/employee/getAllBySalonId', {
      params: { salonId },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    commit('setEmployees', response.data);
    return response.data;
  },

  async getAllEmployees({ commit }) {
    const token = localStorage.getItem('jwt');
    try {
      const response = await axios.get(`${baseURL}/employee/getAllEmployees`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      commit('setEmployees', response.data);
    } catch (error) {
      console.error('Błąd ładowania pracowników:', error);
    }
  },

  async createEmployee(_, payload) {
    const token = localStorage.getItem("jwt");
    try {
      await axios.post(`${baseURL}/employee/createEmployee`, payload, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
    } catch (error) {
      console.error("Błąd tworzenia pracownika:", error.response.data);
      throw error;
    }
  },

  async updateEmployee(_, payload) {
    const token = localStorage.getItem("jwt");
    try {
      const response = await axios.put(`${baseURL}/employee/updateEmployee`, payload, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response;
    } catch (error) {
      throw error.response?.data || 'Nieznany błąd';
    }
  },

  async deleteEmployee(_, employeeId) {
    const token = localStorage.getItem("jwt");
    console.log(employeeId.id);
    try {
      const response = await axios.delete(`${baseURL}/employee/deleteEmployee`, {
        params: { id: employeeId },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response;
    } catch (error) {
      return error.response;
    }
  }

}
